module.exports = __webpack_public_path__ + "img/five9-logo-black.642da8d5.svg";